import i18n from "i18next";
import Backend, { HttpBackendOptions } from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

import { defaultLanguage } from "./config";

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init<HttpBackendOptions>({
    backend: {
      loadPath: "/i18n/{{lng}}.json", // Translation files path
    },
    lng: defaultLanguage || localStorage.getItem("i18nextLng") || "en",
    fallbackLng: {
      "en-GB": ["en"],
      default: ["en"],
    },
    debug: false, // Logs in console
    interpolation: {
      escapeValue: false,
      formatSeparator: ",",
    },
    react: {
      useSuspense: false,
    },
  });

export default i18n;
